import env from '@tencent/vft-common/env';
import Version from '@tencent/vft-common/Version';
import * as urlUtil from '@tencent/vft-common/url';
import atom from '@tencent/vft-atom';
import { getPlayright } from './playRight';
/**
 * 在 h5 或 小程序 或 native 中打开
 * @return {String} h5/ weapp/ native
 */
const openType = function () {
  const version = env.appVersion;

  if (!version) return 'h5';

  const vObj = new Version(version);

  if (!vObj.compare('11.2.5')) return 'h5';

  if ((env.isIos && !vObj.compare('11.6.6')) || (env.isAndroid && !vObj.compare('11.6.5'))) {
    return 'weapp';
  }

  return 'native';
};

export const mqbHandler = async ({ cid = '', vid = '' }) => {
  if (!cid && !vid) return false;

  if (!env.isMqb) return false;

  const type = openType();

  if (type === 'h5') return false;

  if (type === 'weapp') {
    const path = urlUtil.buildUrl('https://m.v.qq.com/x/play.html', { cid, vid, withQBPage: true });
    atom.openUrl(
      `qb://wxapp/?appid=wxa75efa648b60994b&path=${encodeURIComponent(
        path,
      )}&source=200007&withQBPage=true`,
    );
    return true;
  }

  if (type === 'native') {
    const data = await getPlayright({ cid, vid });
    if (!vid) vid = data.vid;

    const { playright } = data.fields;
    // 30 表示支持浏览器
    if (!playright || !playright.includes('30')) return false;

    const url = urlUtil.buildUrl('qb://tencentvideo?vidcontinue=1&source=200007&withQBPage=true', {
      cid,
      vid,
      // 防止webview被关闭，url和伪协议都要加
      withQBPage: true,
    });
    atom.openUrl(url);
    return true;
  }

  return false;
};
